module.exports = __webpack_public_path__ + "static/media/1.ae3628b3.png";